<script setup lang="ts">
import { NTag } from 'naive-ui'
import { useAttrs } from 'vue'

const props = withDefaults(defineProps<{
  type?: 'default' | 'info' | 'success' | 'warning' | 'error'
  size?: 'small' | 'medium' | 'large'
  round?: boolean
  closable?: boolean
  disabled?: boolean
  bordered?: boolean
  checkable?: boolean
  checked?: boolean
  color?: any
  textColor?: string
  onClose?: () => void
  onUpdateChecked?: (checked: boolean) => void
}>(), {
  type: 'default',
  size: 'medium',
  round: false,
  closable: false,
  disabled: false,
  bordered: true,
  checkable: false,
  checked: false,
  color: undefined,
  textColor: undefined,
})

const emit = defineEmits<{
  'close': []
  'update:checked': [checked: boolean]
}>()

const attrs = useAttrs()

const onClose = () => {
  emit('close')
}

const onUpdateChecked = (checked: boolean) => {
  emit('update:checked', checked)
}
</script>

<template>
  <NTag
    :type="type"
    :size="size"
    :round="round"
    :closable="closable"
    :disabled="disabled"
    :bordered="bordered"
    :checkable="checkable"
    :checked="checked"
    :color="color"
    :text-color="textColor"
    v-bind="attrs"
    @close="onClose"
    @update:checked="onUpdateChecked"
  >
    <slot />
  </NTag>
</template>

<style scoped>
/* Custom styles can be added here if needed */
</style>
